import { useEffect, useState } from 'react';
import { StreamChat } from 'stream-chat';
import { CHANNEL_TYPE } from '../consts/channel';

const useSessionChatNotification = (client: StreamChat) => {
    const [hasNewChatNotification, setHasNewChatNotification] = useState<boolean>(false);

    useEffect(() => {
        let clientListener = { unsubscribe: () => {} };
        if (client) {
            clientListener = client.on(event => {
                const isSessionChannel = event.channel_type === CHANNEL_TYPE;
                const isNewMessage =
                    event.type === 'notification.message_new' || event.type === 'message.new';
                if (isSessionChannel && isNewMessage) {
                    if (client.user?.id !== event.user?.id) {
                        setHasNewChatNotification(true);
                    }
                }
            });
        }
        return () => {
            clientListener.unsubscribe();
        };
    }, [client]);

    const resetChatNotification = () => {
        setHasNewChatNotification(false);
    };

    return { hasNewChatNotification, resetChatNotification };
};

export default useSessionChatNotification;
